import React from "react";

interface Props {
  email: string;
  subject?: string;
  body?: string;
  text?: React.ReactNode;
}

export const MailTo = ({ email, subject, body, text }: Props) => {
  const constructMailto = () => {
    const params: string[] = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    return `mailto:${email}${params.length > 0 ? "?" : ""}${params.join("&")}`;
  };

  return <a href={constructMailto()}>{text ?? email}</a>;
};
